import React from 'react';
import { combineClassNames } from '../../../../app/functions';
import './index.scss';

const SliderArrow = ({ className, onClick, variant = 'normal' }) => {
    const slickClasses = className.split(' ');

    return (
        <button
            type="button"
            onClick={onClick}
            className={combineClassNames(
                'shared-slider-arrow',
                slickClasses.includes('slick-next') && 'shared-slider-arrow_next',
                slickClasses.includes('slick-prev') && 'shared-slider-arrow_prev',
                slickClasses.includes('slick-disabled') && 'shared-slider-arrow_disabled',
                variant === 'circular' && 'shared-slider-arrow_variant_circular',
            )}
        />
    );
};

export default SliderArrow;
